import type {StockReachResponse} from '@domain/schedule'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment-timezone'

import {stockReachDataSelector, StockReachData} from '../selectors'

export const StockReachQueryKey = 'stockReach'

interface StockReachParams {
  materialIds: number[] | undefined
  plantCode: string
  timezoneId: string
  endTime: string
  options?: Omit<
    UseQueryOptions<StockReachResponse, AxiosError, StockReachData>,
    'queryKey' | 'queryFn' | 'select'
  >
}

export const useStockReachQuery = ({
  materialIds = [],
  plantCode,
  timezoneId,
  endTime,
  options
}: StockReachParams) => {
  return useQuery<StockReachResponse, AxiosError, StockReachData>({
    queryKey: [StockReachQueryKey, plantCode, materialIds, endTime],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<StockReachResponse>(
        `/plants/${plantCode}/schedules/kpi/stock-reach`,
        {params: {materialIds: materialIds.join(','), to: endTime}, signal}
      )
      return response.data
    },
    enabled: Boolean(materialIds.length),
    select: (response) =>
      stockReachDataSelector(response, timezoneId, moment(endTime).tz(timezoneId)),
    ...options
  })
}
